/*
 * @Author: your name
 * @Date: 2021-07-20 16:16:43
 * @LastEditTime: 2021-07-21 11:52:42
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/config/module/page/basicData.config.js
 */
export default () => ({
  PLATFORM_REGIN: {
    component: () => import(
      /* webpackChunkName: 'BasicDataCenterPage' */
      'allpages/basicData/PLATFORM_REGIN.vue'
    ),
  },
  SKUSHIOPRELEASE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/productRelease/SKUSHIOPRELEASE.vue'
    ),
    labelName: t('平台店铺商品发布')
  },
  SKURELEASE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/productRelease/index.vue'
    ),
    labelName: t('商品发布')
  },
  pro_desc: {
    component: () => import(
      /* webpackChunkName: 'BasicDataCenterPage' */
      'allpages/basicData/pro_desc/pro_desc.vue'
    ),
    label: 'pro_desc'
  },
  /* 2.0: */
  SHOPAUTHORIZE: {
    component: () => import(
      /* webpackChunkName: 'BasicDataCenterPage' */
      'allpages/basicData/authorize.vue'
    ),
    labelName: t('店铺授权'),
  },
  SHOPAUTHORIZEDETAILS: {
    component: () => import(
      /* webpackChunkName: 'BasicDataCenterPage' */
      'allpages/basicData/authorizeDetails.vue'
    ),
  },
  LOGISTICSCOMPANYFILESADDOREDIT: {
    // component: logisticsCompanyFilesAddOrEdit,
    component: () => import(
      /* webpackChunkName: 'BasicDataCenterPage' */
      'allpages/basicData/logisticsCompanyFilesAddOrEdit.vue'
    ),
    labelName: t('物流公司档案'),
  },
  ADDLOGICSTORE: {
    // component: addLogicStore,
    component: () => import(
      /* webpackChunkName: 'BasicDataCenterPage' */
      'allpages/basicData/addLogicStore.vue'
    ),
    labelName: t('新增逻辑仓'),
  },
  ADDALIAS: {
    // component: addAliasOrRegion,
    component: () => import(
      /* webpackChunkName: 'BasicDataCenterPage' */
      'allpages/basicData/addAliasOrRegion.vue'
    ),
    labelName: t('新增别名'),
  },
  ADDREGION: {
    // component: addAliasOrRegion,
    component: () => import(
      /* webpackChunkName: 'BasicDataCenterPage' */
      'allpages/basicData/addAliasOrRegion.vue'
    ),
    labelName: t('新增区域'),
  },
  CP_C_ORG_CHANNEL: {
    // component: channelStore,
    component: () => import(
      /* webpackChunkName: 'BasicDataCenterPage' */
      'allpages/basicData/channelStore.vue'
    ),
    labelName: t('渠道仓档案'),
  },
  NATIONALPROVINCIALMUNICIPALEDIT: {
    // component: nationalProvincialMunicipalEdit,
    component: () => import(
      /* webpackChunkName: 'BasicDataCenterPage' */
      'allpages/basicData/nationalProvincialMunicipalEdit.vue'
    ),
    labelName: t('国家省市区编辑'),
  },
})
